
import { useRef } from 'react';
import { DateInput } from '@mantine/dates';
import '@mantine/dates/styles.css';
import dateIcon from '../../assets/images/date.svg';
import MantineImage from './image';
const MantineDateSelect = (props: any) => {
  const { label, placeholder, onChange, value, classNames, rightSection,error } = props;

  const dateInputRef = useRef<HTMLInputElement>(null);

  const handleRightSectionClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.focus(); // This opens the date picker
    }
  };

  const RightSection = () => {
    return <button type='button' className='w-6' onClick={handleRightSectionClick}>
      <MantineImage src={dateIcon} className='w-5 mr-2' />
    </button>
  }
  return (
    <DateInput
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      classNames={classNames}
      rightSection={<RightSection />}
      ref={dateInputRef}
      error={error}
    />
  );
}
export default MantineDateSelect;